// extracted by mini-css-extract-plugin
export default {"panel":"styles__panel___jhdku","button":"styles__button___RoXso link__button___3l2Cw base__button___zT0JW"};